var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#118f84",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 260 260",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,204.1c-2.3-2.3,1.7-9.9,9-17.2c7.2-7.2,14.9-11.2,17.2-9s-1.7,9.9-9,17.2C187.9,202.4,180.3,206.4,178,204.1z M249,220.6c2.7,2.7-1.3,10.9-8.8,18.5s-15.8,11.5-18.5,8.8c-0.5-0.5-0.7-1.1-0.8-1.9c-27.1,17.4-61,16.2-82.1-4.7 c-0.9-1-1.7-2.1-2.4-3.2c-7.3,3.3-15.5,5.9-24.2,7.9c0.1,0.4,0.2,2.9,0.2,3.2c0,4.9-11.1,8.8-24.7,8.8s-24.7-3.9-24.7-8.8 c0-0.4,0.1-2.9,0.2-3.2C27.8,238,2,218.9,2,186.5c0-44.8,58.2-65.8,67.1-85.7c7.8-17.4-15.2-66-15.2-66l22.3,22.1 c0,0,3.1-38.9,26.9-54.9c-1.5,12.4-9.7,21.4-5.6,52.9c8-19.5,23.8-26.7,23.8-26.7s-23.8,56.3-15,72.6c8.6,16,41.2,31.2,57.5,56 c27.5-25.4,60.5-33.2,77.4-18c20.5,20.8,22,54,5.4,80.9C247.6,219.8,248.4,220,249,220.6z M173,190.6c-0.7,10.8-4.3,20-10.1,27.6 c0.2,0.3,0.3,0.5,0.5,0.7c4,4,20.7-0.9,37.6-17.8c16.9-16.9,21.9-33.6,17.8-37.6c-0.9-0.9-2.4-1.3-4.3-1.3c-2.4,0-5.5,0.7-9,2.1 c-7.8,3.1-16.5,9.2-24.3,17.1C178.1,184.4,175.4,187.5,173,190.6z M235.2,146.9c-3.9-3.9-9.6-5.8-16.2-5.8c-14.6,0-33.9,9-50.2,24.8 c1.5,3.3,2.6,6.8,3.3,10.4c0.7-0.7,1.3-1.4,2-2.1c8.8-8.8,18.7-15.7,27.7-19.3c10.4-4.2,18.9-3.6,24,1.4c9.7,9.7,2,31.9-17.8,51.7 c-14,14.1-29.3,22-40.5,22c-4.6,0-8.5-1.3-11.3-4.2c-0.1-0.1-0.2-0.2-0.3-0.4c-3.2,2.9-6.8,5.5-10.7,7.8c0.5,0.6,1,1.3,1.6,1.8 c12.9,12.9,44,3.5,67.9-20.4c12.1-12.1,20.8-26.2,24.5-39.5C242.7,162.9,241.2,152.8,235.2,146.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnion);
export default __webpack_public_path__ + "static/media/onion.74a7e8a36b3a8a0d26325b82b3d14573.svg";
export { ForwardRef as ReactComponent };